import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { intercomUpdate } from '~/services/intercom';

// Triggers Intercom update on route changes so Product Tours and URL-based features work in SPAs
const useIntercomRouteUpdate = () => {
  const location = useLocation();

  useEffect(() => {
    intercomUpdate();
  }, [location.pathname, location.search, location.hash]);
};

export default useIntercomRouteUpdate;
